/**
 * Util functions for cart meta data
 *
 * @param data
 *  The data from the cart meta data query
 * @returns
 *  If the user has flat rate that can be used (and enough slots).
 */
export function hasFlatRate(
  cartMetadata: any,
  excludedFromFlatRate: boolean = false,
): boolean {
  return (
    !excludedFromFlatRate &&
    cartMetadata?.flatrateSubscription &&
    (cartMetadata?.flatrateSubscription?.availableJobSlots === null ||
      cartMetadata?.flatrateSubscription?.availableJobSlots > 0)
  );
}
